export default __webpack_public_path__ + "static/media/secrets.424e2356.jpg";